<template>
  <div class="row" v-if="canAccess">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-7">
          <div class="card">
            <div class="row">
              <div class="col-md-12">
                <div class="card-header">
                  <h4 class="card-title">Stock Dashboard</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <div class="card">
            <div class="row">
              <div class="col-md-12">
                <div class="card-header text-center">
                  <h4 class="card-title">Nearly Expire Package</h4>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <div><label>Game</label></div>
                  <a-select
                    v-model:value="selects.game"
                    style="width: 100%"
                    placeholder="เลือกเกม"
                    :options="selects.games"
                  />
                </div>
                <div class="col-md-5">
                  <div><label>Payment Method</label></div>
                  <a-select
                    v-model:value="selects.paymentMethod"
                    style="width: 100%"
                    placeholder="เลือกช่องทางการชำระเงิน"
                    :options="selects.paymentMethods"
                  />
                </div>
                <div class="col-md-3">
                  <div><label style="color: transparent">ดึงข้อมูล</label></div>
                  <a-button
                    type="primary"
                    :loading="dataReceiving"
                    @click="getDashboardData()"
                  >
                    ดึงข้อมูล
                  </a-button>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-md-12">
                  <a-card style="font-size: 14px !important">
                    <el-table
                      :data="tableData"
                      style="font-size: 14px !important"
                    >
                      <el-table-column
                        label="Pack Id"
                        align="center"
                        property="packageId"
                      ></el-table-column>
                      <el-table-column
                        label="Package Name"
                        align="center"
                        property="packageName"
                      ></el-table-column>
                      <el-table-column
                        label="Payment Method"
                        align="center"
                        property="paymentMethod"
                      ></el-table-column>
                      <el-table-column
                        label="Price"
                        align="center"
                        property="price"
                      ></el-table-column>
                      <el-table-column
                        label="Expire Date"
                        align="center"
                        property="expiredDateStr"
                      ></el-table-column>
                    </el-table>
                  </a-card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" v-if="canAccess === false">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <a-result
            status="403"
            title="403"
            sub-title="ขออภัย คุณไม่ได้รับอนุญาตให้เข้าถึงหน้านี้"
          >
            <template #extra>
              <a-button type="primary" @click="goToHome">กลับหน้าหลัก</a-button>
            </template>
          </a-result>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as configuration from "../../middleware/configuration";
import * as gameservice from "../../services/game";
import * as paymentservice from "../../services/payment";
import * as dashboardservice from "../../services/dashboard";

import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
import moment from "moment";
import { ElTable, ElTableColumn } from "element-plus";
import { message } from "ant-design-vue";

export default {
  components: {
    Vue3ChartJs,
    [ElTable.name]: ElTable,
    [ElTableColumn.name]: ElTableColumn,
  },
  methods: {
    async getGames() {
      try {
        let res = await gameservice.get("games");
        res.data.map((m) => {
          this.selects.games.push({ value: m.id, label: m.name });
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.selects.gameLoaded = true;
      }
    },
    async getPaymentMethods() {
      try {
        let res = await paymentservice.getPaymentMethods();
        res.data.map((m) => {
          this.selects.paymentMethods.push({ value: m.code, label: m.name });
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.selects.paymentLoaded = true;
      }
    },
    async getDashboardData() {
      let dataReq = {
        game: this.selects.game,
        period: this.selects.period,
        paymentMethod: this.selects.paymentMethod,
      };

      await this.getNearlyExpirePackage(dataReq);
    },
    async getNearlyExpirePackage(dataReq) {
      if (dataReq.game === null || dataReq.paymentMethod === null) {
        message.error("กรุณาเลือก Criteria ให้ครบ");
        return;
      }
      this.dataReceiving = false;

      try {
        let res = await dashboardservice.get("NearlyExpirePackage", dataReq);
        let data = res.data.map((d) => {
          d.expiredDateStr = this.getDate(d.expiredDate);
          return d;
        });
        this.tableData = data;
        message.success("ดึงข้อมูลสำเร็จ");
      } catch (error) {
        message.error("ดึงข้อมูลไม่สำเร็จ");
      } finally {
        this.dataReceiving = false;
      }
    },
    getDate(value) {
      if (value) return moment(value).format("DD/MM/YYYY");
      return "";
    },
  },
  data() {
    return {
      canAccess: null,
      dataReceiving: false,
      selects: {
        games: [],
        game: null,
        gameLoaded: false,
        period: null,
        periods: [
          {
            value: "today",
            label: "Today",
          },
          {
            value: "last7days",
            label: "Last 7 Days",
          },
          {
            value: "thisyear",
            label: "This Year",
          },
        ],
        paymentMethods: [],
        paymentMethod: null,
        paymentLoaded: false,
      },
      tableData: [],
    };
  },
  async beforeMount() {
    this.uid = await configuration.getUid();
    let result = await configuration.getIdTokenResult();
    if (result) {
      this.role = result.claims?.role || this.role;
      if (this.role === "admin" || this.role === "manager") {
        await this.getGames();
        await this.getPaymentMethods();
        this.canAccess = true;
      } else {
        this.canAccess = false;
      }
    } else {
      this.canAccess = false;
    }
  },
};
</script>

<style>
.table > thead > tr > th,
.el-table table > thead > tr > th {
  font-size: 13.5px !important;
}
</style>